import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const Sandwich = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/' name='Сендвiчi'/>
            <main className={s.main}>
                <Product name='З яєшнею баликом та сиром' price='110 грн.' weight='260г.' info1='хліб/бабл-вафля, балик, сир тостовий, помідор, майонез, вершкове масло, яйце, листя салату'/>
                <Product name='З куркою та помідорами' price='100 грн.' weight='200г.' info1='хліб/бабл-вафля, бедро запечене, сир тостовий, соус сирний, сіль, перець, помідор, листя салату'/>
                <Product name='З авокадо та помідорами' price='80 грн.' weight='200г.' info1='хліб/бабл-вафля, помідор, авокадо, зелена цибуля, масло вершкове, сіль, перець, кріп, листя салату'/>
                <Product name='З лососем' price='130 грн.' weight='195г.' info1='хліб/бабл-вафля, лосось, вершкове масло, кріп, листя салату, огірок, помідор'/>
                <Product name='З ковбасою' price='90 грн.' weight='200г.' info1='хліб/бабл-вафля, помідор, копчена ковбаса, твердий сир, вершкове масло, листя салату'/>
            </main>
        </div>
    )
}

export default Sandwich;